export const HOME_ROUTE_BILLING: readonly string[] = ['/settings', 'billing'];
export const HOME_ROUTE_LICENCES: readonly string[] = ['/settings', 'licences'];
export const HOME_ROUTE_ANOMALIES: readonly string[] = ['/reports', 'anomalies'];
export const HOME_ROUTE_ENTRA_ADMIN_ROLES: readonly string[] = ['/reports', 'entra-admin-roles'];
export const HOME_ROUTE_M365_LICENCES: readonly string[] = ['/reports', 'm365-license-assignment'];
